<script>
import DatePicker from "vue2-datepicker";
import { required, requiredIf } from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import { gender_type, work_shift, staff_type } from "@/helpers/global.variable";

//  Staff Component

export default {
  page: {
    title: "StaffForm",
  },
  components: {
    DatePicker,
    VueDropify,
    VueCropper,
  },
  data() {
    return {
      gender_type,
      work_shift,
      staff_type,
      rolesOptions: [],
      permissions: {},
      messaagePermissions: {
        last_active: "",
        is_access_message_app: false,
        is_edit_booking_guest: false,
        is_edit_group_tag_setting: false,
        is_edit_guest_inbox_group: false,
        is_edit_lobby_inbox_group: false,
        is_edit_maintenance_request: false,
        is_edit_service_request: false,
        is_sent_guest_inbox_message: false,
        is_sent_lobby_inbox_message: false,
        is_view_booking_guest: false,
        is_view_guest_inbox_group: false,
        is_view_lobby_inbox_group: false,
        is_view_maintenance_request: false,
        is_view_service_request: false,
      },
      createError: false,
      errorMessage: "",
      staff: {
        title: null,
        first_name: null,
        last_name: null,
        staff_id: null,
        email: null,
        password: null,
        mobile: null,
        mobile_iso: "US",
        gender: null,
        birth_date: null,
        blood_group: null,
        work_shift: null,
        staff_type: null,
        role: null,
        emergency_contact_name: null,
        emergency_contact_number: null,
        emergency_contact_number_iso: "US",
        emergency_relation: null,
        special_notes: null,
        is_kyc_done: false,
        kyc_doc_image: null,
        kyc_doc_name: null,
        kyc_doc_number: null,
        profile_picture: null,
      },
      emergency_contact_number_code: "+1 ",
      mobile_code: "+1 ",
      kyc_doc_image_imgURL: "",
      profile_picture_imgURL: "",
      submitted: false,
      isBtnLoading: false,
      isSaveAndAddNew: false,
    };
  },
  computed: {
    ...authComputed,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  async mounted() {
    await this.getRoles();
    this.setIfEdit();
  },
  methods: {
    async getRoles() {
      await UserService.getRoleList()
        .then((roles) => {
          roles.map((role) => {
            this.rolesOptions.push({
              value: role.id,
              text: role.name,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    setIfEdit() {
      if (this.currentProps.isEdit) {
        UserService.getStaffDetails(this.currentProps.selectedStaff.id)
          .then((response) => {
            this.staff.title = response.title;
            this.staff.first_name = response.first_name;
            this.staff.last_name = response.last_name;
            this.staff.staff_id = response.staff_id;
            this.staff.email = response.email;
            this.staff.mobile = response.mobile
              .trim()
              .substring(response.mobile.indexOf(" ") + 1);
            this.staff.gender = response.gender;
            this.staff.birth_date = response.birth_date;
            this.staff.blood_group = response.blood_group;
            this.staff.work_shift = response.work_shift;
            this.staff.staff_type = response.staff_type;
            this.staff.role = response.role.id;
            this.staff.emergency_contact_name = response.emergency_contact_name;
            this.staff.emergency_contact_number =
              response.emergency_contact_number !== null
                ? response.emergency_contact_number
                    .trim()
                    .substring(
                      response.emergency_contact_number.indexOf(" ") + 1
                    )
                : "";
            this.staff.emergency_relation = response.emergency_relation;
            this.staff.special_notes = response.special_notes;
            this.staff.is_kyc_done = response.is_kyc_done;
            this.staff.kyc_doc_image = response.kyc_doc_image;
            this.staff.kyc_doc_name = response.kyc_doc_name;
            this.staff.kyc_doc_number = response.kyc_doc_number;
            this.staff.profile_picture = response.profile_picture;
            this.permissions = response.iot_app_setting;
            this.messaagePermissions = response.message_app_setting;
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.staff.mobile !== "") {
          this.staff.mobile = this.mobile_code + this.staff.mobile;
        } else {
          this.staff.mobile_iso = "US";
        }
        if (this.staff.emergency_contact_number !== "") {
          this.staff.emergency_contact_number =
            this.mobile_code + this.staff.emergency_contact_number;
        } else {
          this.staff.emergency_contact_number_iso = "US";
        }
        if (this.kyc_doc_image_imgURL !== "") {
          this.staff.kyc_doc_image = this.createImageFromBase(
            this.$refs.cropper.getCroppedCanvas().toDataURL(),
            "kyc_doc_image.jpg"
          );
        } else {
          this.staff.kyc_doc_image = "";
        }
        if (this.profile_picture_imgURL !== "") {
          this.staff.profile_picture = this.createImageFromBase(
            this.$refs.cropper.getCroppedCanvas().toDataURL(),
            "profile_picture.jpg"
          );
        } else {
          this.staff.profile_picture = "";
        }
        if (this.currentProps.isEdit) {
          let staffData = new FormData();
          Object.keys(this.staff).map((key) => {
            if (this.staff[key] !== null) {
              staffData.append(key, this.staff[key]);
            }
            if (key === "role") {
              this.rolesOptions.map((item) => {
                if (item.text === this.staff[key]) {
                  staffData.set(key, item.value);
                }
              });
            }
            if (key === "id") {
              staffData.delete(key);
            }
            if (key === "profile_picture") {
              if (
                typeof this.staff[key] === "string" &&
                this.staff.profile_picture !== ""
              ) {
                staffData.delete(key);
              }
            }
            if (key === "kyc_doc_image") {
              if (
                typeof this.staff[key] === "string" &&
                this.staff.kyc_doc_image !== ""
              ) {
                staffData.delete(key);
              }
            }
            if (key == "profile_picture_imgURL") {
              staffData.delete(key);
            }
            if (key == "kyc_doc_image_imgURL") {
              staffData.delete(key);
            }
          });
          staffData.append("user_hotel", this.hotel.id);
          staffData.append("user_type", "hotel_staff");
          staffData.append(
            "message_app_setting",
            JSON.stringify(this.messaagePermissions)
          );
          staffData.append("iot_app_setting", JSON.stringify(this.permissions));
          UserService.editStaff(this.currentProps.selectedStaff.id, staffData)
            .then((response) => {
              this.$emit("submitted", response);
              this.isBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              if (error.response.status === 500) {
                Middleware.notification(
                  "Internal server error !!",
                  "danger",
                  3000
                );
              } else {
                this.isBtnLoading = false;
                this.createError = true;
                this.errorMessage = error.response.data;
              }
              errorHandler(error);
            });
        } else {
          let staffData = new FormData();
          Object.keys(this.staff).map((key) => {
            if (this.staff[key] !== null) {
              staffData.append(key, this.staff[key]);
            }
          });
          staffData.append(
            "message_app_setting",
            JSON.stringify(this.messaagePermissions)
          );
          staffData.append("iot_app_setting", JSON.stringify(this.permissions));
          staffData.append("user_hotel", this.hotel.id);
          staffData.append("user_type", "hotel_staff");
          staffData.append("is_active", true);
          staffData.append("is_staff", true);
          UserService.createStaff(staffData)
            .then((staff) => {
              if (!this.isSaveAndAddNew) {
                this.$emit("submitted", staff);
              } else {
                this.$emit("saveAndAddNew", staff);
                this.staff = {
                  title: null,
                  first_name: null,
                  last_name: null,
                  staff_id: null,
                  email: null,
                  password: null,
                  mobile: "",
                  mobile_iso: "US",
                  gender: null,
                  birth_date: null,
                  blood_group: null,
                  work_shift: null,
                  staff_type: null,
                  role: null,
                  emergency_contact_name: null,
                  emergency_contact_number: "",
                  emergency_contact_number_iso: "US",
                  emergency_relation: null,
                  special_notes: null,
                  is_kyc_done: false,
                  kyc_doc_image: null,
                  kyc_doc_name: null,
                  kyc_doc_number: null,
                  profile_picture: null,
                };
                this.emergency_contact_number_code = "+1 ";
                this.mobile_code = "+1 ";
                this.kyc_doc_image_imgURL = "";
                this.profile_picture_imgURL = "";
              }
              this.isBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              if (error.response.status === 500) {
                Middleware.notification(
                  "Internal server error !!",
                  "danger",
                  3000
                );
              } else {
                this.isBtnLoading = false;
                this.createError = true;
                this.errorMessage = error.response.data;
              }
              errorHandler(error);
            });
        }
      }
    },
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    changeProfilePicture(event) {
      if (event[0] !== undefined) {
        this.staff.profile_picture = event[0] == undefined ? null : event[0];
        this.profile_picture_imgURL = URL.createObjectURL(event[0]);
      } else {
        this.staff.profile_picture = "";
        this.staff.profile_picture_imgURL = "";
      }
    },
    changeKYCImage(event) {
      if (event[0] !== undefined) {
        this.staff.kyc_doc_image = event[0] == undefined ? null : event[0];
        this.kyc_doc_image_imgURL = URL.createObjectURL(event[0]);
      } else {
        this.staff.kyc_doc_image = "";
        this.kyc_doc_image_imgURL = "";
      }
    },
    countryChange(phoneType, code) {
      if (phoneType === "mobile_number") {
        this.staff.mobile_iso = code.iso2;
        this.mobile_code = "+" + code.dialCode + " ";
      } else {
        this.staff.emergency_contact_number_iso = code.iso2;
        this.emergency_contact_number_code = "+" + code.dialCode + " ";
      }
    },
    createImageFromBase(dataUrl, filename) {
      var arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
  validations: {
    staff: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      email: {
        required,
      },
      password: {
        required: requiredIf(function () {
          if (!this.currentProps.isEdit) {
            return true;
          }
        }),
      },
      mobile: {
        required,
      },
      staff_id: {
        required,
      },
      role: {
        required,
      },
      kyc_doc_image: {
        require: requiredIf(function () {
          if (this.staff.is_kyc_done && this.submitted) {
            return true;
          }
        }),
      },
      kyc_doc_name: {
        require: requiredIf(function () {
          if (this.staff.is_kyc_done && this.submitted) {
            return true;
          }
        }),
      },
      kyc_doc_number: {
        require: requiredIf(function () {
          if (this.staff.is_kyc_done && this.submitted) {
            return true;
          }
        }),
      },
    },
  },
};
</script>

<template>
  <div class="offcanvas-body">
    <div class="row">
      <div class="col-md-12">
        <hr />
      </div>
      <div role="tablist">
        <b-card no-body class="mb-1 shadow-none">
          <b-card-header header-tag="header" v-b-toggle.accordion-1 role="tab">
            <h6 class="my-1">
              <a class="text-dark" href="javascript: void(0);"
                ><b-card-title>
                  <h4 class="card-title">
                    {{ this.currentProps.isEdit ? "Update" : "Add" }} Staff
                    General Details
                  </h4>
                </b-card-title></a
              >
            </h6>
          </b-card-header>
          <b-collapse
            id="accordion-1"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group
                        class="mb-3"
                        label="Title"
                        label-for="title-input"
                      >
                        <b-form-input
                          id="title-input"
                          type="text"
                          placeholder="Ex : Mr/Mrs"
                          v-model="staff.title"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group class="mb-3" label-for="first-last-input">
                        <span slot="label">
                          First Name <span class="text-danger">*</span>
                        </span>

                        <b-form-input
                          id="first-last-input"
                          type="text"
                          placeholder="Ex : John"
                          v-model="staff.first_name"
                          :class="{
                            'is-invalid':
                              submitted && $v.staff.first_name.$error,
                          }"
                          autocomplete="off"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.staff.first_name.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.first_name.required"
                            >Staff first name is required.</span
                          >
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-3 ccv_amount_cls">
                      <b-form-group class="mb-3" label-for="last-name-input">
                        <span slot="label">
                          Last Name <span class="text-danger">*</span>
                        </span>
                        <b-form-input
                          id="last-name-input"
                          type="text"
                          placeholder="Ex : doe"
                          v-model="staff.last_name"
                          :class="{
                            'is-invalid':
                              submitted && $v.staff.last_name.$error,
                          }"
                          autocomplete="off"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.staff.last_name.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.last_name.required"
                            >Staff last name is required.</span
                          >
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group class="mb-3" label-for="staff-id-input">
                        <span slot="label">
                          Staff Id <span class="text-danger">*</span>
                        </span>
                        <b-form-input
                          id="staff-id-input"
                          type="text"
                          placeholder="Ex : Staff001"
                          v-model="staff.staff_id"
                          :class="{
                            'is-invalid':
                              (submitted && $v.staff.staff_id.$error) ||
                              (createError && errorMessage.staff_id),
                          }"
                          autocomplete="off"
                        ></b-form-input>
                        <div
                          v-if="
                            (submitted && $v.staff.staff_id.$error) ||
                            (createError && errorMessage.staff_id)
                          "
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.staff_id.required"
                            >Staff staff Id is required.</span
                          >
                          <span v-if="createError && errorMessage.staff_id">{{
                            errorMessage.staff_id[0]
                          }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group class="mb-3" label-for="email-input">
                        <span slot="label">
                          Email <span class="text-danger">*</span>
                        </span>
                        <b-form-input
                          id="email-input"
                          type="email"
                          placeholder="Ex : Johndeo@gmail.com"
                          v-model="staff.email"
                          :class="{
                            'is-invalid':
                              (submitted && $v.staff.email.$error) ||
                              (createError && errorMessage.email),
                          }"
                          autocomplete="new-email"
                        ></b-form-input>
                        <div
                          v-if="
                            (submitted && $v.staff.email.$error) ||
                            (createError && errorMessage.email)
                          "
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.email.required"
                            >Staff email is required.</span
                          >
                          <span v-if="createError && errorMessage.email">{{
                            errorMessage.email[0]
                          }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group class="mb-3" label-for="password-input">
                        <span slot="label">
                          Password
                          <span
                            :class="
                              currentProps.isEdit ? 'd-none' : 'text-danger'
                            "
                            >*</span
                          >
                        </span>
                        <b-form-input
                          id="password-input"
                          type="password"
                          placeholder="******"
                          v-model="staff.password"
                          :class="{
                            'is-invalid': submitted && $v.staff.password.$error,
                          }"
                          autocomplete="new-password"
                          data-lpignore="true"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.staff.password.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.password.required"
                            >Staff password is required.</span
                          >
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        class="mb-3"
                        label="Mobile"
                        label-for="mobile-input"
                      >
                        <span slot="label"
                          >Mobile <span class="text-danger">*</span></span
                        >
                        <vue-tel-input
                          class="text-dark-gray"
                          v-model="staff.mobile"
                          autoFormat
                          :autoDefaultCountry="false"
                          :defaultCountry="
                            currentProps.selectedStaff !== null
                              ? currentProps.selectedStaff.mobile_iso
                              : 'US'
                          "
                          :dropdownOptions="{
                            showDialCodeInList: true,
                            showDialCodeInSelection: true,
                            showFlags: true,
                            width: '390px',
                            showSearchBox: true,
                          }"
                          @country-changed="
                            countryChange('mobile_number', ...arguments)
                          "
                          :class="{
                            'is-invalid':
                              (submitted && $v.staff.mobile.$error) ||
                              (createError && errorMessage.mobile),
                          }"
                        ></vue-tel-input>
                        <div
                          v-if="
                            (submitted && $v.staff.mobile.$error) ||
                            (createError && errorMessage.mobile)
                          "
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.mobile.required"
                            >Staff mobile is required.</span
                          >
                          <span v-if="createError && errorMessage.mobile">{{
                            errorMessage.mobile[0]
                          }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        class="mb-3 form-label"
                        label="Gender"
                        label-for="gender-input"
                      >
                        <b-form-select
                          class="form-select"
                          id="gender-input"
                          type="text"
                          :options="gender_type"
                          v-model="staff.gender"
                          autocomplete="off"
                        >
                          <template #first>
                            <b-form-select-option :value="null"
                              >Choose...</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        class="mb-3"
                        label="Birth Date"
                        label-for="birth-date-input"
                      >
                        <date-picker
                          id="birth-date-input"
                          v-model="staff.birth_date"
                          format="YYYY-MM-DD"
                          value-type="format"
                          type="date"
                          placeholder="YYYY-MM-DD"
                        ></date-picker>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                        class="mb-3"
                        label="Blood Group"
                        label-for="blood-input"
                      >
                        <b-form-input
                          id="blood-input"
                          type="text"
                          placeholder="Ex : AB+"
                          v-model="staff.blood_group"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div></div
              ></b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" v-b-toggle.accordion-2 role="tab">
            <h6 class="my-1">
              <a class="text-dark" href="javascript: void(0);">
                <b-card-title>
                  <h4 class="card-title">Other Details</h4>
                </b-card-title>
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text
                ><div class="col-md-12">
                  <hr />
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group class="mb-3" label-for="role-input">
                        <span slot="label">
                          Role <span class="text-danger">*</span>
                        </span>
                        <b-form-select
                          class="form-select"
                          id="role-input"
                          type="text"
                          autocomplete="off"
                          v-model="staff.role"
                          :options="rolesOptions"
                          :class="{
                            'is-invalid': submitted && $v.staff.role.$error,
                          }"
                        >
                        </b-form-select>
                        <div
                          v-if="submitted && $v.staff.role.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.role.required"
                            >Staff role is required.</span
                          >
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group
                        class="mb-3"
                        label="Work Shift"
                        label-for="work-shift-input"
                      >
                        <b-form-select
                          class="form-select"
                          id="work-shift-input"
                          type="text"
                          autocomplete="off"
                          :options="work_shift"
                          v-model="staff.work_shift"
                        >
                          <template #first>
                            <b-form-select-option :value="null"
                              >Choose...</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col-md-4 ccv_amount_cls">
                      <b-form-group
                        class="mb-3"
                        label="Staff Type"
                        label-for="staff-type-input"
                      >
                        <b-form-select
                          class="form-select"
                          id="staff-type-input"
                          type="text"
                          autocomplete="off"
                          :options="staff_type"
                          v-model="staff.staff_type"
                        >
                          <template #first>
                            <b-form-select-option :value="null"
                              >Choose...</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group
                        class="mb-3"
                        label="Emergency Contact Person"
                        label-for="emergency-contact-person-input"
                      >
                        <b-form-input
                          id="emergency-contact-person-input"
                          type="text"
                          placeholder="Emergency contact person name"
                          v-model="staff.emergency_contact_name"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group
                        class="mb-3"
                        label="Emergency Contact Mobile"
                        label-for="emergency-contact-mobile-input"
                      >
                        <vue-tel-input
                          class="text-dark-gray"
                          v-model="staff.emergency_contact_number"
                          autoFormat
                          :autoDefaultCountry="false"
                          :defaultCountry="
                            currentProps.selectedStaff !== null
                              ? currentProps.selectedStaff
                                  .emergency_contact_number_iso
                              : 'US'
                          "
                          :dropdownOptions="{
                            showDialCodeInList: true,
                            showDialCodeInSelection: true,
                            showFlags: true,
                            width: '390px',
                            showSearchBox: true,
                          }"
                          @country-changed="
                            countryChange('emg_number', ...arguments)
                          "
                        ></vue-tel-input>
                      </b-form-group>
                    </div>
                    <div class="col-4">
                      <b-form-group
                        class="mb-3"
                        label="Emergency Contact Relation"
                        label-for="emergency-contact-relation-input"
                      >
                        <b-form-input
                          id="emergency-contact-relation-input"
                          type="text"
                          autocomplete="off"
                          placeholder="Emergency contacted person relation"
                          v-model="staff.emergency_relation"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-4">
                      <b-form-group
                        class="mb-3"
                        label="Note"
                        label-for="note-input"
                      >
                        <b-form-textarea
                          id="note-input"
                          placeholder="Some note for employee..."
                          v-model="staff.special_notes"
                        ></b-form-textarea>
                      </b-form-group>
                    </div>
                  </div></div
              ></b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" v-b-toggle.accordion-3 role="tab">
            <h6 class="my-1">
              <a class="text-dark mt-1" href="javascript: void(0);"
                ><b-card-title>
                  <h4 class="card-title">Permissions</h4>
                </b-card-title>
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <div class="col-md-12">
                  <h4 class="card-title">IOT App Permissions</h4>
                  <hr />
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div
                      class="col-md-3 text-dark"
                      v-for="(perms, index) in permissions"
                      :key="index"
                    >
                      <b-form-group
                        class="mb-3 text-capitalize"
                        :label="index.replace(/_|is/g, ' ')"
                      >
                        <div class="form-check form-switch form-switch-md mb-3">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="permissions[index]"
                            @change="zisBtnLoading = false"
                            autocomplete="off"
                            :checked="perms"
                          />
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <h4 class="card-title">Message App Setting</h4>
                  <hr />
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div
                      class="col-md-3 text-dark"
                      v-for="(mperms, index) in messaagePermissions"
                      :key="index"
                    >
                      <b-form-group
                        class="mb-3 text-capitalize"
                        :label="index.replace(/_|is/g, ' ')"
                      >
                        <div class="form-check form-switch form-switch-md mb-3">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="messaagePermissions[index]"
                            @change="isBtnLoading = false"
                            autocomplete="off"
                            :checked="mperms"
                          />
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" v-b-toggle.accordion-4 role="tab">
            <h6 class="my-1">
              <a class="text-dark mt-1" href="javascript: void(0);"
                ><b-card-title>
                  <h4 class="card-title">KYC/Profile Details</h4>
                </b-card-title>
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text
                ><div class="col-md-12">
                  <hr />
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group
                        class="mb-3"
                        label="KYC Done"
                        label-for="is-kyc-done-switch"
                      >
                        <div class="form-check form-switch form-switch-md mb-3">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="staff.is_kyc_done"
                            @change="isBtnLoading = false"
                            autocomplete="off"
                          />
                        </div>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group
                        class="mb-3"
                        label="KYC Document Name"
                        label-for="kyc-document-name-input"
                      >
                        <b-form-input
                          placeholder="KYC document name"
                          id="kyc-document-name-input"
                          :disabled="!staff.is_kyc_done"
                          type="text"
                          v-model="staff.kyc_doc_name"
                          :class="{
                            'is-invalid':
                              submitted && $v.staff.kyc_doc_name.$error,
                          }"
                          autocomplete="off"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.staff.kyc_doc_name.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.kyc_doc_name.required"
                            >KYC name is required.</span
                          >
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <b-form-group
                        class="mb-3"
                        label="KYC Document Number"
                        label-for="kyc-document-number-input"
                      >
                        <b-form-input
                          placeholder="KYC document number"
                          id="kyc-document-number-input"
                          type="text"
                          :disabled="!staff.is_kyc_done"
                          v-model="staff.kyc_doc_number"
                          :class="{
                            'is-invalid':
                              submitted && $v.staff.kyc_doc_number.$error,
                          }"
                          autocomplete="off"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.staff.kyc_doc_number.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.staff.kyc_doc_number.required"
                            >KYC doc number is required.</span
                          >
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label for="kyc_doc">KYC DOCUMENT</label>
                      <VueDropify
                        v-if="kyc_doc_image_imgURL == ''"
                        @upload="changeKYCImage($event)"
                        :src="staff.kyc_doc_image ? staff.kyc_doc_image : ''"
                        message="Drop image here or click to select"
                        :disabled="!staff.is_kyc_done"
                        id="kyc-document-input"
                        plain
                        :class="{
                          'is-invalid':
                            submitted && $v.staff.kyc_doc_image.$error,
                        }"
                      />
                      <vue-cropper
                        v-else
                        ref="cropper"
                        :src="kyc_doc_image_imgURL"
                        alt="Source Image"
                        class="position-relative w-100 object-fit"
                        :minCropBoxWidth="150"
                        :minCropBoxHeight="150"
                      >
                      </vue-cropper>
                      <div
                        v-if="submitted && $v.staff.kyc_doc_image.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.staff.kyc_doc_image.required"
                          >KYC doc image is required.</span
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label for="kyc_doc">PROFILE PICTURE</label>
                      <VueDropify
                        v-if="profile_picture_imgURL == ''"
                        @upload="changeProfilePicture($event)"
                        :src="
                          staff.profile_picture ? staff.profile_picture : ''
                        "
                        message="Drop image here or click to select"
                      />
                      <vue-cropper
                        v-else
                        ref="cropper"
                        :src="profile_picture_imgURL"
                        alt="Source Image"
                        class="position-relative w-100 object-fit"
                        :minCropBoxWidth="150"
                        :minCropBoxHeight="150"
                      >
                      </vue-cropper>
                    </div>
                  </div></div
              ></b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <div class="col-md-12">
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelSubmit"
          >Cancel</b-button
        >
        <b-button
          v-if="this.currentProps.isEdit === false"
          class="float-end ms-2"
          variant="outline-primary"
          type="button"
          @click="saveAndAddNew"
          :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
        >
          <i
            v-if="isSaveAndAddNew === true && isBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i
          >Save & Add</b-button
        >
        <b-button
          class="float-end"
          variant="outline-primary"
          type="button"
          @click="handleSubmit"
          :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
        >
          <i
            v-if="isSaveAndAddNew !== true && isBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          {{ currentProps.isEdit ? "Update" : "Save" }}
        </b-button>
      </div>
    </div>
  </div>
</template>
